<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <h1 v-if="this.isModifyMode == false">{{ $t('menu.goods-register-request') }}</h1>
            <h1 v-if="this.isModifyMode == true">{{ $t('menu.goods-edit') }}</h1>
            <piaf-breadcrumb />
            <div class="separator mb-5"></div>

        </b-colxx>
    </b-row>
    <b-row>
        <b-colxx xxs="12">
            <b-card no-body>
                <b-card-body class="wizard wizard-default">

                    <!-- 상품 유형 -->
                    <select-goods-type v-if="registerNew" @selectGoodsType="selectGoodsType"></select-goods-type>

                    <goods-wizard v-else-if="tablFlag" @callDone="saveReqGoods" @saveGoods="saveGoods" @register="registerGoods" :last-step-end="true" :with-validate="true">

                        <tab name="상품정보" :selected="true" :validate="validateFirstStep">
                            <div class="wizard-basic-step">
                                <edit-goods-contents />
                            </div>
                        </tab>

                        <tab name="옵션/가격" :validate="validateSecondStep">
                            <div class="wizard-basic-step">
                                <edit-goods-options />
                            </div>
                        </tab>

                        <tab name="사용조건" :validate="validateThirdStep">
                            <div class="wizard-basic-step">
                                <edit-goods-condition />
                            </div>
                        </tab>

                        <tab name="판매채널" v-if="goodsType != 'Booking'" :validate="validateFourthStep">
                            <div class="wizard-basic-step">
                                <edit-goods-sale-info />
                            </div>
                        </tab>

                        <tab name="판매정보" :validate="validateFifthStep">
                            <div class="wizard-basic-step">
                                <edit-goods-show-info />
                            </div>
                        </tab>

                        <tab type="done">
                            <div class="wizard-basic-step text-center">
                            </div>
                        </tab>

                        <template slot="footer" slot-scope="props">
                            <div class="wizard-footer-left">
                                <!-- <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button>-->
                                <wizard-button @click.native="props.previousTab()">Previous</wizard-button>
                            </div>
                            <div class="wizard-footer-right">
                                <wizard-button @click.native="props.nextTab()" class="wizard-footer-right">Next</wizard-button>

                                <!-- <wizard-button v-else @click.native="alert('Done')" class="wizard-footer-right finish-button" >{{props.isLastStep ? 'Done' : 'Next'}}</wizard-button>-->
                            </div>
                        </template>

                    </goods-wizard>

                </b-card-body>
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import FormWizard from "../../components/Form/Wizard/FormWizard";
import Tab from "../../components/Form/Wizard/Tab";
import SelectGoodsType from "./components/edit/SelectGoodsType";
import EditGoodsContents from "./components/edit/EditGoodsContents";
import EditGoodsOptions from "./components/edit/EditGoodsOptions";
import EditGoodsCondition from "./components/edit/EditGoodsCondition";
import EditGoodsSaleInfo from "./components/edit/EditGoodsSaleInfo";
import EditGoodsShowInfo from "./components/edit/EditGoodsShowInfo";

import {
    mapGetters,
    mapActions
} from "vuex";

import GoodsRegisterRequestWizard from "./GoodsRegisterRequestWizard";

export default {
    components: {
        "goods-wizard": GoodsRegisterRequestWizard,
        "form-wizard": FormWizard,
        "tab": Tab,
        "select-goods-type": SelectGoodsType,
        "edit-goods-contents": EditGoodsContents,
        "edit-goods-options": EditGoodsOptions,
        "edit-goods-condition": EditGoodsCondition,
        "edit-goods-sale-info": EditGoodsSaleInfo,
        "edit-goods-show-info": EditGoodsShowInfo,

    },

    data() {
        return {
            tablFlag: false,
            registerNew: false,
            isRegisted: false,
            isModifyMode: false,
            isReqModifyMode: false,
            goodsParamsId: null, //등록된 상품아이디
            registerId: null, //등록대기 상품아이디
            copyRegisterId: null,
            copyGoodsId: null,
            copyFlag: false,
            testMode: false
        }
    },

    computed: {
        ...mapGetters(['goodsName', 'intro', 'mainImage', 'subImages', 'options', 'hours', 'storeCodes',
            'hasSalesPeriod', 'saleStartDate', 'saleEndDate',
            'expirationDateSetting', 'validDayCount', 'validFromDate', 'validToDate', 'cancellableTimeValue',
            'currentUser', 'siteName', 'goodsType',
            'saveSuccess', 'saveError', 'registerReqSuccess', 'registerReqError'
        ]),

    },

    mounted() {
        const params = this.$route.params

        // store 초기화
        this.goodsReset();
        this.tablFlag = true

        //신규상품
        this.registerId = params.registerId !== undefined ? params.registerId : null
        if (this.registerId !== null) {
            this.isReqModifyMode = true
            this.goodsId({
                registerId: this.registerId
            });
            this.reqGoodsInfo({
                currentUser: this.currentUser,
                siteName: this.siteName
            });
            this.goodsChannelCodesOptions({
                currentUser: this.currentUser,
                siteName: this.siteName,
                modeFlag: true
            })
        }

        //신규복사등록
        this.copyRegisterId = params.copyRegisterId !== undefined ? params.copyRegisterId : null
        if (this.copyRegisterId !== null) {
            this.copyFlag = true
            // console.log(this.copyFlag);
            this.goodsId({
                registerId: this.copyRegisterId
            });
            this.reqGoodsInfo({
                currentUser: this.currentUser,
                siteName: this.siteName
            });
            this.goodsChannelCodesOptions({
                currentUser: this.currentUser,
                siteName: this.siteName,
                modeFlag: true
            })

        }

        //상품
        this.goodsParamsId = params.goodsId !== undefined ? params.goodsId : null
        if (this.goodsParamsId !== null) {
            this.isModifyMode = true
            this.goodsId({
                registerId: this.goodsParamsId
            });
            this.goodsInfo({
                currentUser: this.currentUser,
                siteName: this.siteName
            });
            this.goodsChannelCodesOptions({
                currentUser: this.currentUser,
                siteName: this.siteName,
                modeFlag: true
            })

        }

        //상품복사등록
        this.copyGoodsId = params.copyGoodsId !== undefined ? params.copyGoodsId : null
        if (this.copyGoodsId !== null) {
            this.copyFlag = true
            this.goodsId({
                registerId: this.copyGoodsId
            });
            this.goodsInfo({
                currentUser: this.currentUser,
                siteName: this.siteName
            });
        }

        //처음 상품등록시, 상품유형 선택여부 체크
        if (((this.registerId == null && this.goodsParamsId == null) && this.copyRegisterId == null) && this.copyGoodsId == null) {
            this.registerNew = true

        }

    },

    watch: {

        registerReqSuccess(val) {
            if (val === true) {
                this.$notify('success', "Register Success", '등록 요청되었습니다.', {
                    duration: 3500,
                    permanent: false
                })
            }

            if (this.copyFlag) {
                this.$router.push(`../goods-register-status`)
            } else {
                if (this.isReqModifyMode) {
                    this.$router.push(`../goods-register-status`)

                } else {
                    this.$router.push(`goods-register-status`)
                }
            }

        },

        registerReqError(val) {
            // console.log(val);
            if (val != null) {
                this.$notify("error", "Register Error", '등록 요청 실패', {
                    duration: 3500,
                    permanent: false
                });
            }
        },

        saveSuccess(val) {
            // console.log(val);
            if (val === true) {
                this.$notify('success', "Save Success", '저장되었습니다.', {
                    duration: 3500,
                    permanent: false
                })
            }

            if (this.copyFlag) {
                this.$router.push(`../goods-register-status`)
            } else {
                if (this.isReqModifyMode) {
                    this.$router.push(`../goods-register-status`)

                } else {
                    this.$router.push(`goods-register-status`)
                }
            }

        },

        saveError(val) {
            // console.log(val);
            if (val != null) {
                this.$notify("error", "Save Error", '저장 실패', {
                    duration: 3500,
                    permanent: false
                });
            }
        },

        registerNew(val) {
            // console.log(val);
        },

        goodsType(val) {
            // console.log(val);
        },

    },

    methods: {

        ...mapActions(['goodsReset', 'goodsId', 'reqGoodsCreate', 'reqGoodsUpdate', 'goodsRegister', 'goodsInfo', 'reqGoodsInfo',
            'goodsUpdateIntro', 'goodsUpdateCondition', 'goodsUpdateOptionsAndUsableHours', 'goodsUpdateOptions', 'goodsUpdateUsage',
            'goodsChannelCodesOptions'
        ]),

        /**
         * 1. 등록대기상품 생성
         * 2. 등록대기상품 수정 isReqModifyMode
         * 3. 등록대기상품 등록요청
         * 4. 상품 수정 isModifyMode
         */

        //신규상품 임시저장
        saveReqGoods() {
            if (this.isReqModifyMode == true) {
                this.reqGoodsUpdate({
                    currentUser: this.currentUser,
                    siteName: this.siteName,
                    registerId: this.registerId
                })
            } else { //대기상품 생성
                this.reqGoodsCreate({
                    currentUser: this.currentUser,
                    siteName: this.siteName
                })
            }
        },

        //신규상품 등록요청
        registerGoods(isRegisted) {
            // console.log("registerGoods")
            this.goodsRegister({
                currentUser: this.currentUser,
                siteName: this.siteName,
                registerId: this.registerId
            })
            this.isRegisted = isRegisted
        },

        //기존상품 수정
        saveGoods(tabNo) {

            if (this.isModifyMode === true) {

                switch (tabNo) {
                    case 0: { //상품정보
                        this.goodsUpdateIntro({
                            currentUser: this.currentUser,
                            siteName: this.siteName,
                            registerId: this.goodsParamsId
                        })
                        return
                    }

                    case 1: {
                        // 예약, 예약권 : 옵션및 이용가능시간 변경
                        if (this.goodsType == "Booking" || this.goodsType == "BookingCoupon") {
                            this.goodsUpdateOptionsAndUsableHours({
                                currentUser: this.currentUser,
                                siteName: this.siteName,
                                registerId: this.goodsParamsId
                            })
                        } else {
                            // 쿠폰, 금액권 : 옵션정보변경
                            this.goodsUpdateOptions({
                                currentUser: this.currentUser,
                                siteName: this.siteName,
                                registerId: this.goodsParamsId
                            })
                        }
                        return
                    }
                    case 2: { //사용조건
                        this.goodsUpdateCondition({
                            currentUser: this.currentUser,
                            siteName: this.siteName,
                            registerId: this.goodsParamsId
                        })
                        return
                    }

                    case 3: { //판매채널 / 판매정보
                        if (this.goodsType == "Booking") {
                            this.goodsUpdateUsage({
                                currentUser: this.currentUser,
                                siteName: this.siteName,
                                registerId: this.goodsParamsId
                            })
                        }
                        return
                    }

                    case 4: { // 판메정보
                        this.goodsUpdateUsage({
                            currentUser: this.currentUser,
                            siteName: this.siteName,
                            registerId: this.goodsParamsId
                        })
                        return
                    }

                }
            }
        },

        selectGoodsType(registerNew) {
            this.registerNew = registerNew
        },

        validateFirstStep() { //상품정보
            let flag = true

            if (!this.testMode) {
                if (this.goodsName == null || this.goodsName == "") {
                    flag = false
                    this.$notify("error", "Error", "상품명을 입력해 주세요", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                // console.log(this.intro );
                // if(this.intro == null || this.intro == "") {
                //   flag = false
                //   this.$notify("error", "Error", "상품설명을 입력해 주세요", {
                //     duration: 3500,
                //     permanent: false
                //   });
                //   return
                // }

                if (this.mainImage == null) {
                    flag = false
                    this.$notify("error", "Error", "대표이미지를 등록해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (this.subImages.length == 0) {
                    flag = false
                    this.$notify("error", "Error", "추가 이미지를 1장 이상 등록해주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

            }

            return flag
        },

        validateSecondStep() { //옵션/가격
            let flag = true
            var vm = this

            if (!this.testMode) {
                var nameFlag = true
                var priceFlag = true
                var inventoryFlag = true
                var hourFlag = true
                var headcntFlag = true
                var bookingCouponPriceFlag = true

                console.log(this.options)

                this.options.forEach(function (value, index) {
                    // console.log(value);
                    if (value.optionName == "") {
                        nameFlag = false
                    }
                    if (value.listPrice == "" || value.salePrice == "") {
                        priceFlag = false
                    }
                    if (value.inventory == "") {
                        inventoryFlag = false
                    }

                    if (vm.goodsType == "Booking" || vm.goodsType == "BookingCoupon") {
                        if (value.headcount == "" || value.headcount < 0) {
                            headcntFlag = false
                        }
                    }

                    if (vm.goodsType == "BookingCoupon") {
                        if (value.listPrice == "0" || value.salePrice == "0") {
                            bookingCouponPriceFlag = false
                        }
                    }

                })

                if (this.goodsType == "Booking" || this.goodsType == "BookingCoupon") {
                    if (this.hours.length == 0 || (this.hours[0].hour == null || this.hours[0].minute == null)) {
                        hourFlag = false
                    }
                }

                if (!hourFlag) {
                    flag = false
                    this.$notify("error", "Error", "적용 시간을 1개 이상 입력해 주세요", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (!nameFlag) {
                    flag = false
                    this.$notify("error", "Error", "옵션명을 정확히 입력해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (!priceFlag || !bookingCouponPriceFlag) {
                    flag = false
                    this.$notify("error", "Error", "가격정보를 정확히 입력해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (!inventoryFlag) {
                    flag = false
                    this.$notify("error", "Error", "재고 수량을 정확히 입력해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (!headcntFlag) {
                    flag = false
                    this.$notify("error", "Error", "인원을 설정해 주시기 바랍니다.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

            }
            return flag
        },

        validateThirdStep() { //사용조건

            let flag = true
            if (!this.testMode) {

                if (this.storeCodes.length < 1) {
                    flag = false
                    this.$notify("error", "Error", " 이용가능한 매장을 1개 이상 등록해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (this.hasSalesPeriod) {
                    if (this.saleStartDate == null || this.saleEndDate == null) {
                        flag = false
                        this.$notify("error", "Error", " 판매 기간을 정확히 입력해 주세요.", {
                            duration: 3500,
                            permanent: false
                        });
                        return
                    }
                }

                if (this.expirationDateSetting == "SetDayCount") {
                    if (this.validDayCount == null || this.validDayCount == '') {
                        if (this.saleStartDate == null || this.saleEndDate == null) {
                            flag = false
                            this.$notify("error", "Error", " 유효 기간을 정확히 입력해 주세요.", {
                                duration: 3500,
                                permanent: false
                            });
                            return
                        }
                    }
                } else {
                    if (this.validFromDate == null || this.validFromDate == null) {
                        flag = false
                        this.$notify("error", "Error", " 유효 기간을 정확히 입력해 주세요.", {
                            duration: 3500,
                            permanent: false
                        });
                        return
                    }
                }

                let expirationFlag = true
                if (this.expirationDateSetting == "SetDayCount") {
                    if (this.validDayCount == '') {
                        expirationFlag = false
                    }
                } else {
                    if (this.validFromDate == null || this.validToDate == null) {
                        expirationFlag = false
                    }
                }

                if (!expirationFlag) {
                    flag = false
                    this.$notify("error", "Error", "유효기간을 정확히 입력해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }

                if (this.cancellableTimeValue == null && this.goodsType != "Booking") {
                    flag = false
                    this.$notify("error", "Error", "취소 가능한 기간을 입력해 주세요.", {
                        duration: 3500,
                        permanent: false
                    });
                    return
                }
            }
            return flag
        },

        validateFourthStep() { //판매채널
            return true;

        },

        validateFifthStep() { //판매정보
            return true;
        },

    }
};
</script>
